import Vue from 'vue';
import vuescroll from 'vuescroll';
import VueGtag from 'vue-gtag';
import VueI18n from 'vue-i18n';

// @ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';

import {uiBus} from '@/services/services';
import {EventEmitter} from 'events';

import Loading from '@/views/components/Loading.vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';

import store from './store';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import '@/assets/styles/app.scss';
import {getI18n} from "@/services/init/languageInit";
import {IOnOffHandlers} from "@/models/IOnOffHandlers";

const googleMapKey = "AIzaSyDufLKfGQLDG2lHxBEBLfFtsjfAHG859O0";
const ANALYTICS_CODE = "UA-107846409-4";

// google maps integration
// @ts-ignore
Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapKey,
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },

  installComponents: true,
});

// here we will configure vue and all the plugins or similar we will use

Vue.config.productionTip = false;

// telephone input plugin
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


// vuescroll, component to do a scroll system that will be seen the same in every device
Vue.use(vuescroll);

// component to show a loading animation
Vue.component('Loading', Loading);


// custom communication bus
// needed to declare this.$uiBus for components!
declare module 'vue/types/vue' {
  interface Vue {
    $uiBus: EventEmitter;
    $ons: (o: IOnOffHandlers, currentOns?: IOnOffHandlers) => IOnOffHandlers;
    $offs: (o: IOnOffHandlers) => IOnOffHandlers;
  }
}

Vue.prototype.$uiBus = uiBus;
Vue.prototype.$ons = (ons: IOnOffHandlers, current: IOnOffHandlers = {}): IOnOffHandlers => {
  Object.keys(ons)
    .forEach(eachEvent => uiBus.on(eachEvent, ons[eachEvent]));
  return Object.assign(current, ons);
};
Vue.prototype.$offs = (offs: IOnOffHandlers) => {
  Object.keys(offs)
    .forEach(eachEvent => uiBus.off(eachEvent, offs[eachEvent]));
};


// internationalization system
Vue.use(VueI18n);

export const i18n: VueI18n = getI18n();

Vue.use(VueGtag, {
  config: { id: ANALYTICS_CODE },
});


new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
